import { render, staticRenderFns } from "./ModalCreateChatbot.vue?vue&type=template&id=a1faaafc&scoped=true&"
import script from "./ModalCreateChatbot.vue?vue&type=script&lang=js&"
export * from "./ModalCreateChatbot.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateChatbot.vue?vue&type=style&index=0&id=a1faaafc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1faaafc",
  null
  
)

export default component.exports